export const STORAGE_KEY_THEME = 'theme';

export const STORAGE_KEY_FCM_TOKEN = 'FCMToken';

export const STORAGE_KEY_ACCESS_TOKEN = 'accessToken';
